import { render, staticRenderFns } from "./addOrEditModel.vue?vue&type=template&id=712248cb&scoped=true&"
import script from "./addOrEditModel.vue?vue&type=script&lang=ts&"
export * from "./addOrEditModel.vue?vue&type=script&lang=ts&"
import style0 from "./addOrEditModel.vue?vue&type=style&index=0&id=712248cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712248cb",
  null
  
)

export default component.exports